import { SVGProps } from 'react';

export const TextAlignRightIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 14 12"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M0 0.55C0 0.246243 0.25128 0 0.56125 0H12.9087C13.2187 0 13.47 0.246243 13.47 0.55C13.47 0.853757 13.2187 1.1 12.9087 1.1H0.56125C0.25128 1.1 0 0.853757 0 0.55Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.92 4C4.92 3.69624 5.14651 3.45 5.42592 3.45H12.9641C13.2435 3.45 13.47 3.69624 13.47 4C13.47 4.30376 13.2435 4.55 12.9641 4.55H5.42592C5.14651 4.55 4.92 4.30376 4.92 4Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M0 7.45C0 7.14624 0.235944 6.9 0.526995 6.9H12.943C13.2341 6.9 13.47 7.14624 13.47 7.45C13.47 7.75376 13.2341 8 12.943 8H0.526995C0.235944 8 0 7.75376 0 7.45Z"
        fill="#474747"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M5.07 10.9C5.07 10.5962 5.29253 10.35 5.56704 10.35H12.973C13.2475 10.35 13.47 10.5962 13.47 10.9C13.47 11.2038 13.2475 11.45 12.973 11.45H5.56704C5.29253 11.45 5.07 11.2038 5.07 10.9Z"
        fill="#474747"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default TextAlignRightIcon;
